var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGowagr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 112C86.9279 112 112 86.9279 112 56C112 25.0721 86.9279 0 56 0C25.0721 0 0 25.0721 0 56C0 86.9279 25.0721 112 56 112Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.561 52.9191L62.9073 37.2654C59.1107 33.4688 52.9777 33.4688 49.1811 37.2654C49.1081 37.3384 49.0497 37.4114 48.9767 37.4699L33.4252 53.036C29.6578 56.8034 29.6578 62.9218 33.4252 66.6892C37.1926 70.4566 43.311 70.4566 47.0784 66.6892L55.9858 57.7817L64.8494 66.6454C66.003 67.7989 67.3756 68.6021 68.8213 69.0547C68.8213 69.0547 68.8213 69.0547 68.8359 69.0547C68.9673 69.0986 69.1133 69.1424 69.2447 69.1716C69.2593 69.1716 69.2739 69.1862 69.2885 69.1862C69.4199 69.2154 69.566 69.2592 69.6974 69.2884C69.712 69.2884 69.7266 69.2884 69.7412 69.303C72.8223 69.9309 76.1516 69.0547 78.5464 66.66C82.3576 62.8633 82.3576 56.7158 78.561 52.9191Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4819 68.3545C57.0509 66.9235 54.7291 66.9235 53.3127 68.3545L50.3338 71.3334C48.0266 73.6406 49.6621 77.5832 52.9184 77.5832H58.8762C62.1325 77.5832 63.768 73.6406 61.4608 71.3334L58.4819 68.3545Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGowagr);
export default __webpack_public_path__ + "static/media/gowagr.5e772eb19f781da610e84c65b06aaf25.svg";
export { ForwardRef as ReactComponent };